'use strict';
var app = require('angular').module('dialogs', []);

app.factory('dialog', ['$uibModal', require('./dialogsFactory')]);
